import { patch } from "@src/appV2/api/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import { useMutation, type UseMutationOptions } from "@tanstack/react-query";
import { type AxiosError } from "axios";
import { z } from "zod";

const endNegotiationResponseSchema = z.object({
  negotiation: z.object({
    _id: z.string(),
  }),
});

export type EndNegotiationResponse = z.infer<typeof endNegotiationResponseSchema>;

export function useEndNegotiation(
  options: UseMutationOptions<
    EndNegotiationResponse,
    AxiosError<EndNegotiationResponse>,
    string
  > = {}
) {
  return useMutation({
    mutationFn: async (negotiationId: string) => {
      const response = await patch({
        url: `${environmentConfig.REACT_APP_BASE_API_URL}/negotiation/${negotiationId}/reject`,
        data: undefined,
        responseSchema: endNegotiationResponseSchema,
      });
      return response.data;
    },
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.END_NEGOTIATION_FAILURE,
    },
    ...options,
  });
}
